import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, Instagram } from 'lucide-react';
import { mockData } from '../mock';

const ThankYou = () => {
  return (
    <div className="px-6 sm:px-12 lg:px-20 pt-32 sm:pt-40 pb-20 sm:pb-24 flex items-center justify-center min-h-[70vh]">
      <div className="max-w-xl mx-auto text-center">
        
        {/* Success Icon - Smaller */}
        <div className="mb-8 sm:mb-10 flex justify-center">
          <CheckCircle size={60} strokeWidth={1} className="text-black" />
        </div>

        {/* Thank You Message - Smaller */}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extralight text-black mb-8 tracking-wide">
          Thank You
        </h1>
        
        <div className="w-12 h-px bg-black/30 mx-auto mb-8"></div>
        
        <p className="text-sm sm:text-base text-black/60 mb-6 leading-loose font-light">
          Your message has been received! I'll get back to you as soon as possible.
        </p>
        
        <p className="text-xs sm:text-sm text-black/50 mb-12 leading-loose font-light">
          I typically respond within 24-48 hours. In the meantime, feel free to explore my portfolio 
          or connect with me on Instagram.
        </p>

        {/* Action Buttons - Compact */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-3 px-10 py-3.5 border border-black text-black text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light hover:bg-black hover:text-white transition-all duration-300"
          >
            <Home size={14} strokeWidth={1} />
            Return Home
          </Link>
          
          <a
            href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-10 py-3.5 border border-black text-black text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light hover:bg-black hover:text-white transition-all duration-300"
          >
            <Instagram size={14} strokeWidth={1} />
            Follow on Instagram
          </a>
        </div>

        {/* Additional Info - Minimal */}
        <div className="mt-12 sm:mt-16 pt-8 sm:pt-10 border-t border-black/10">
          <p className="text-[8px] sm:text-[9px] tracking-[2px] uppercase text-black/30 font-light mb-3">
            Need immediate assistance?
          </p>
          <a 
            href={`mailto:${mockData.contact.email}`}
            className="text-xs sm:text-sm text-black/60 hover:text-black transition-colors font-light border-b border-black/20 hover:border-black"
          >
            {mockData.contact.email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
